module.exports = __webpack_public_path__ + "img/wohslogo.9aa9b43d.jpg";